import Vue from 'vue'
import App from './ui/App.vue'
import router from './ui/router'
import Notifications from 'vue-notification'
import Debug from 'debug';
import store from '@/ui/store';
import {initFirebase} from '@/firebase';
import {initSentry} from '@/sentry';
import vuetify from '@/ui/vuetify';
import {AppSettings} from '@/application/AppSettings';

const log = Debug('main.ts')

log(AppSettings.IS_DEV ? 'Started App in Dev-Mode' : 'Started App in Prod-Mode');

Vue.config.productionTip = false;
Vue.use(Notifications, {duration: 4000});

initFirebase(store);
initSentry(AppSettings.IS_DEV, store);

new Vue({
  store,
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app-wrapper');
